<script lang="ts">
  import { api, navigate, type Me } from './lib/api';
  import { router } from './lib/router.svelte';
  import Login from './pages/Login.svelte';
  import Join from './pages/Join.svelte';
  import Operator from './pages/Operator.svelte';
  import Director from './pages/Director.svelte';
  import Admin from './pages/Admin.svelte';
  import Latency from './pages/Latency.svelte';

  let me = $state<Me | null>(null);
  let loadError = $state<string | null>(null);

  async function refresh() {
    try {
      me = await api.get<Me>('/api/me');
      loadError = null;
    } catch (err) {
      loadError = (err as Error).message;
    }
  }

  // Direct camera links: /cam/3?key=... -> exchange the key for a session, then drop it from the URL.
  async function tokenLogin(key: string) {
    try {
      await api.post('/api/token-login', { key });
      history.replaceState({}, '', location.pathname);
      router.query = new URLSearchParams();
    } catch (err) {
      loadError = (err as Error).message;
    }
    await refresh();
  }

  const key = router.query.get('key');
  if (key && router.path.startsWith('/cam/')) void tokenLogin(key);
  else void refresh();

  const camNumber = $derived(router.path.match(/^\/cam\/(\d+)/)?.[1] ?? null);

  $effect(() => {
    if (!me) return;
    const p = me.principal;
    const path = router.path;
    if (path === '/latency') return;
    if (!p) {
      if (path !== '/login') navigate(`/login?next=${encodeURIComponent(location.pathname)}`, true);
      return;
    }
    if (path === '/login' || path === '/') {
      const next = router.query.get('next');
      if (next && next.startsWith('/') && next !== '/login' && next !== '/') navigate(next, true);
      else if (p.kind === 'token') navigate('/join', true);
      else if (p.role === 'admin' || p.role === 'director') navigate('/director', true);
      else navigate('/join', true);
    }
  });
</script>

{#if loadError && !me?.principal}
  <div class="page"><div class="panel"><h2>Cannot open talkback</h2><p class="error">{loadError}</p><button onclick={() => navigate('/login')}>Log in</button></div></div>
{:else if !me}
  <div class="page muted">Loading…</div>
{:else if router.path === '/latency'}
  <Latency />
{:else if !me.principal}
  <Login onlogin={refresh} dev={me.dev} />
{:else if camNumber}
  {#key camNumber}<Operator principal={me.principal} number={Number(camNumber)} />{/key}
{:else if router.path === '/director' && (me.principal.role === 'director' || me.principal.role === 'admin')}
  <Director principal={me.principal} />
{:else if router.path.startsWith('/admin') && me.principal.role === 'admin'}
  <Admin />
{:else}
  <Join principal={me.principal} onlogout={refresh} />
{/if}
